import React from "react";

import { Button } from "@/atoms/button/Button";
import { Modal } from "@/atoms/modal/Modal";
import { useTranslation } from "@/core/i18n";

import { PersonalisationHeading } from "./PersonalisationHeading";

type ConfirmLeaveModalProps = {
  readonly open: boolean;
  readonly onContinue: () => void;
  readonly onLeave: () => void;
};

export const ConfirmLeaveModal = ({ open, onContinue, onLeave }: ConfirmLeaveModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onContinue}
      headerClassName="px-8 pt-8"
      bodyClassName="px-8"
      footer={
        <div className="flex flex-col gap-4 p-8">
          <Button style="primary" size="large" fullWidth onClick={onContinue}>
            {t("common.continue")}
          </Button>
          <Button style="secondary" size="large" fullWidth onClick={onLeave}>
            {t("confirmLeaveModal.leaveLater")}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-9">
        <div className="flex flex-col gap-9">
          <PersonalisationHeading size="sm">{t("confirmLeaveModal.title")}</PersonalisationHeading>
          <div className="flex flex-col gap-9 text-[#6B7070]">
            <p className="text-sm font-normal leading-[18px] text-[#6B7070]">
              {t("confirmLeaveModal.bodyLine1")}
            </p>
            <p className="text-sm font-normal leading-[18px] text-[#6B7070]">
              {t("confirmLeaveModal.bodyLine2")}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};
